module.exports = "<app-app-header></app-app-header>\r\n<carousel [interval]=\"myInterval\" [noWrap]=\"noWrapSlides\" [(activeSlide)]=\"activeSlideIndex\" class=\"hidden-sm\">\r\n    <slide *ngFor=\"let slide of slides; let index=index\">\r\n        <img [src]=\"slide.image\" class=\"img-responsive center-block\">\r\n    </slide>\r\n</carousel>\r\n<div class=\"container\" style=\"padding-bottom: 70px;\">\r\n\r\n    <ui-view></ui-view>\r\n\r\n</div>\r\n<!-- /container -->\r\n\r\n<app-app-footer></app-app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 831
// module chunks = 1